import { IAllCenterAddress } from '@nkr/models/all-centers';
import { Table } from 'react-bootstrap';

interface IProps {
    addressData: IAllCenterAddress[],
    name: string
}

const Grid = (props: IProps) => {
    return (
        <Table bordered striped condensed className='table-nkr-styled'>
            <thead>
                <tr>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}> Address Type</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }} >Address</th>
                </tr>
            </thead>
            <tbody>
                {props.addressData !== null && props.addressData.map((x, i) =>
                    <tr key={i}>
                        <td key={`addressType${i}`} style={{ textAlign: 'center' }}>{x.addressType}</td>
                        <td key={`address${i}`} style={{ textAlign: 'center' }}>{x.fullAddress}</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
}

export default Grid;